/* ===== Mandrelekids Shopify Theme JS ===== */

/* Sale countdown timer */
(function(){
  function updateTimer(){
    var now=new Date(),end=new Date();
    end.setHours(23,59,59,999);
    var diff=Math.max(0,end-now);
    var h=Math.floor(diff/3600000),m=Math.floor((diff%3600000)/60000),s=Math.floor((diff%60000)/1000);
    var el=document.getElementById('sale-timer');
    if(el)el.textContent=String(h).padStart(2,'0')+':'+String(m).padStart(2,'0')+':'+String(s).padStart(2,'0');
  }
  updateTimer();
  setInterval(updateTimer,1000);
})();

/* Trust text rotator */
(function(){
  var idx=0;
  var el=document.getElementById('trust-text');
  if(!el)return;
  var msgs;
  var decode=function(s){var t=document.createElement('textarea');t.innerHTML=s;return t.value;};
  try{
    msgs=JSON.parse(el.getAttribute('data-messages')||'[]').map(decode);
  }catch(e){
    msgs=[];
  }
  if(!msgs.length)msgs=[el.textContent.trim()];
  setInterval(function(){
    el.style.opacity='0';
    el.style.transform='translateY(-12px)';
    setTimeout(function(){
      idx=(idx+1)%msgs.length;
      el.textContent=msgs[idx];
      el.style.opacity='1';
      el.style.transform='translateY(0)';
    },400);
  },3500);
})();

/* Review carousel dots */
(function(){
  var track=document.getElementById('reviews-track');
  var dotsContainer=document.getElementById('review-dots');
  if(!track||!dotsContainer)return;
  var cards=track.querySelectorAll('.review-card');
  cards.forEach(function(_,i){
    var dot=document.createElement('button');
    dot.className='carousel-dot'+(i===0?' active':'');
    dot.setAttribute('aria-label','Go to review '+(i+1));
    dot.onclick=function(){
      cards[i].scrollIntoView({behavior:'smooth',block:'nearest',inline:'start'});
    };
    dotsContainer.appendChild(dot);
  });
  var observer=new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if(e.isIntersecting){
        var idx=Array.from(cards).indexOf(e.target);
        dotsContainer.querySelectorAll('.carousel-dot').forEach(function(d,di){
          d.className='carousel-dot'+(di===idx?' active':'');
        });
      }
    });
  },{root:track,threshold:0.6});
  cards.forEach(function(c){observer.observe(c)});

  function scrollByCard(dir){
    var card=cards[0];if(!card)return;
    var step=card.getBoundingClientRect().width + 20;
    track.scrollBy({left:dir*step,behavior:'smooth'});
  }
  var prev=document.getElementById('reviews-prev');
  var next=document.getElementById('reviews-next');
  if(prev)prev.onclick=function(){scrollByCard(-1)};
  if(next)next.onclick=function(){scrollByCard(1)};
})();

/* Bed Quiz */
var quizAge='',quizStyle='';
function quizSelectAge(age){
  quizAge=age;
  document.getElementById('quiz-step-age').style.display='none';
  document.getElementById('quiz-step-style').style.display='block';
  updateQuizBars(1);
}
function quizSelectStyle(style){
  quizStyle=style;
  document.getElementById('quiz-step-style').style.display='none';
  document.getElementById('quiz-step-result').style.display='block';
  updateQuizBars(2);
  showQuizResults();
}
function quizReset(){
  quizAge='';quizStyle='';
  document.getElementById('quiz-step-age').style.display='block';
  document.getElementById('quiz-step-style').style.display='none';
  document.getElementById('quiz-step-result').style.display='none';
  updateQuizBars(0);
}
function updateQuizBars(step){
  var bars=document.querySelectorAll('.quiz-bar');
  bars.forEach(function(b,i){b.className='quiz-bar'+(i<=step?' active':'')});
}
function showQuizResults(){
  var container=document.getElementById('quiz-results');
  if(!container)return;
  function localizedUrl(path){
    if(!path || path.indexOf('/')!==0)return path;
    var root=(window.MK_ROOT_URL||'/').replace(/\/$/,'');
    return (root+path).replace(/\/{2,}/g,'/');
  }
  var fromLabel=container.getAttribute('data-from-label')||'From';
  /* Use actual product links from the store */
  var houseBeds=[
    {handle:'montessori-house-floor-bed-toddler-kids-bed-with-rails',name:'(A) Toddler House Floor Bed',url:'/products/montessori-house-floor-bed-toddler-kids-bed-with-rails',img:'https://mandrelekids.com/cdn/shop/files/I88A4864natural.jpg?v=1711869657&width=200',price:'\u20ac225,48'},
    {handle:'toddler-house-bed-on-legs',name:'(G) Toddler House Bed on Legs',url:'/products/toddler-house-bed-on-legs',img:'https://mandrelekids.com/cdn/shop/files/I88A4755white.jpg?v=1711469108&width=200',price:'\u20ac234,23'},
    {handle:'toddler-house-bed-on-legs-with-extra-storage',name:'(D) House Bed on Legs with Storage',url:'/products/toddler-house-bed-on-legs-with-extra-storage',img:'https://mandrelekids.com/cdn/shop/files/I88A4765white.jpg?v=1711470052&width=200',price:'\u20ac380,02'}
  ];
  var floorBeds=[
    {handle:'montessori-floor-bed-toddler-kids-bed-with-rails-round-safety',name:'(B) Floor Bed (Rounded Opening)',url:'/products/montessori-floor-bed-toddler-kids-bed-with-rails-round-safety',img:'https://mandrelekids.com/cdn/shop/files/I88A4989natural_804fc12d-1b4c-4792-9a5f-6ca29d1496bd.jpg?v=1711291817&width=200',price:'\u20ac208,96'},
    {handle:'toddler-floor-bed-with-rounded-opening-on-both-sides',name:'(C) Floor Bed (Both Sides)',url:'/products/toddler-floor-bed-with-rounded-opening-on-both-sides',img:'https://mandrelekids.com/cdn/shop/files/I88A0982natural_1273fb40-4b59-420b-8b11-cc9c46e11950.jpg?v=1767085394&width=200',price:'\u20ac241,03'},
    {handle:'montessori-toddler-floor-bed-without-doors',name:'(F) Floor Bed (without Doors)',url:'/products/montessori-toddler-floor-bed-without-doors',img:'https://mandrelekids.com/cdn/shop/files/I88A2552natural.jpg?v=1711780081&width=200',price:'\u20ac184,66'}
  ];
  var bestSellers=[houseBeds[0],floorBeds[0],
    {handle:'toddler-high-floor-bed',name:'(E) Toddler High Floor Bed',url:'/products/toddler-high-floor-bed',img:'https://mandrelekids.com/cdn/shop/files/B0CTMTZZ7C.MAIN.jpg?v=1711471266&width=200',price:'\u20ac250,75'}
  ];
  var live=window.MK_QUIZ_PRODUCTS||{};
  function resolve(p){
    var d=live[p.handle];
    if(!d)return p;
    return {handle:p.handle,name:d.name||p.name,url:d.url||p.url,img:d.img||p.img,price:d.price||p.price};
  }
  var picks=(quizStyle==='house'?houseBeds:quizStyle==='floor'?floorBeds:bestSellers).map(resolve);
  container.innerHTML=picks.map(function(p,i){
    return '<a href="'+localizedUrl(p.url)+'" class="quiz-result-item" style="position:relative">'
      +(i===0?'<span class="result-rank">#1</span>':'')
      +'<img src="'+p.img+'" alt="'+p.name+'">'
      +'<div style="flex:1;min-width:0"><p class="result-name">'+p.name+'</p><p class="result-price">'+fromLabel+' '+p.price+'</p></div>'
      +'<span style="color:var(--muted-fg)">&rarr;</span></a>';
  }).join('');
}
